import { Chip } from '@mui/material';
import { getPartnerStatusMeta } from '../../utils/partnerStatus';

const PartnerStatusBadge = ({ status }) => {
  const config = getPartnerStatusMeta(status);

  return (
    <Chip
      label={config.label}
      size="small"
      sx={{
        height: 24,
        fontWeight: 600,
        fontSize: '0.75rem',
        bgcolor: config.chipBackgroundColor,
        color: config.chipColor,
        borderRadius: '6px',
      }}
    />
  );
};

export default PartnerStatusBadge;
